const TOKEN_RE = /(^|[\s\n])((?:\/[A-Za-z0-9_.:-]+)|(?:#[A-Za-z0-9_-]+))/g;

export type MarkedTokenKind = 'skill' | 'tool' | 'plain';

export interface MarkedPart {
  kind: MarkedTokenKind;
  text: string;
}

export function splitMarkedTokens(text: string): MarkedPart[] {
  const parts: MarkedPart[] = [];
  let last = 0;
  TOKEN_RE.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = TOKEN_RE.exec(text))) {
    const lead = m[1];
    const token = m[2];
    const start = m.index + lead.length;
    if (start > last) {
      parts.push({ kind: 'plain', text: text.slice(last, start) });
    }
    parts.push({ kind: token.startsWith('#') ? 'tool' : 'skill', text: token });
    last = start + token.length;
  }
  if (last < text.length) {
    parts.push({ kind: 'plain', text: text.slice(last) });
  }
  if (parts.length === 0) {
    parts.push({ kind: 'plain', text });
  }
  return parts;
}

export function UserMessageTokens({ text }: { text: string }) {
  const parts = splitMarkedTokens(text);
  return (
    <p className="whitespace-pre-wrap text-chat" data-testid="user-message-tokens">
      {parts.map((p, i) =>
        p.kind === 'plain' ? (
          <span key={i}>{p.text}</span>
        ) : (
          <strong
            key={i}
            data-testid="composer-token"
            data-token-kind={p.kind}
            className="font-semibold underline decoration-current/40"
          >
            {p.text}
          </strong>
        ),
      )}
    </p>
  );
}
